import JoinModalButtonContainer from 'components/JoinModalButton/JoinModalButtonContainer'
import JoinModalButtonData from 'components/JoinModalButton/JoinModalButtonData'
export default {
  Container: JoinModalButtonContainer,
  Data: JoinModalButtonData,
}
